export const formatFcfa = (amount) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XOF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

export const STATUS_LABELS = {
  paid: { label: 'Soldé', color: 'bg-green-100 text-green-800' },
  partially_paid: { label: 'Partiel', color: 'bg-yellow-100 text-yellow-800' },
  overdue: { label: 'Impayé', color: 'bg-red-100 text-red-800' },
  due_soon: { label: 'Échéance proche', color: 'bg-orange-100 text-orange-800' },
  pending: { label: 'À venir', color: 'bg-gray-100 text-gray-800' },
};

export const StatusBadge = ({ status }) => {
  const info = STATUS_LABELS[status] || STATUS_LABELS.pending;
  return (
    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${info.color}`}>
      {info.label}
    </span>
  );
};
